




























import { Vue, Component, Prop } from "vue-property-decorator";
import { TwoPointsPicker } from "./TwoPointsPicker"
import { RectOutline } from "./RectOutline"
import { EditableLine } from "@/stellar-globe-components/Line";
import { ToolModule } from "@/modules/ToolModule";
import { GlobeObject } from "@/stellar-globe-components/GlobeObject";
import { EquatorialCoord } from "@hscmap/angle";
import { vec3 } from "gl-matrix";
import { angle60html } from "@/utils/angle";
import { PanLayer } from "@hscmap/stellar-globe";
import { Layer2Component } from '@/stellar-globe-components';

@Component({
  components: {
    TwoPointsPicker,
    RectOutline,
    EditableLine,
    GlobeObject,
    PanLayer: Layer2Component(PanLayer),
  },
})
export default class extends Vue {
  @Prop({ required: true })
  module!: ToolModule

  get lineLength() {
    const { c0, c1 } = this.module.line!
    const d = vec3.dist(c0.xyz, c1.xyz)
    const t = 2 * Math.asin(d / 2)
    return angle60html(t)
  }
}
